<script lang="ts">
  import { onMount } from 'svelte';
  import { session } from '../lib/auth.svelte';
  import { WHATSAPP_LINK } from '../lib/billing';

  onMount(() => {
    void (async () => {
      const tid = session.value?.tenantId;
      if (tid) {
        await fetch('/api/auth/v1/public/delete-pending', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tenantId: tid }),
        }).catch(() => {});
      }
    })();
  });
</script>

<div class="page">
  <main class="card">
    <h1>Pago cancelado</h1>
    <p>No se realizó ningún cargo. Puede intentar de nuevo cuando quiera.</p>
    <a class="btn" href="/billing/trial-expired">Volver a planes</a>
    <a class="link" href={WHATSAPP_LINK} target="_blank" rel="noopener">Ayuda por WhatsApp</a>
  </main>
</div>

<style>
  .page { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 2rem; background: #f8fafc; }
  .card { max-width: 420px; background: #fff; border-radius: 14px; padding: 2rem; text-align: center; border-top: 4px solid #f59e0b; box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 8px 24px rgba(0,0,0,0.04); }
  h1 { color: #0f172a; margin: 0 0 0.5rem; font-size: 22px; }
  p { color: #64748b; font-size: 14px; }
  .btn { display: block; margin-top: 1.25rem; padding: 0.75rem; background: #1e293b; color: #fff; border-radius: 8px; text-decoration: none; font-weight: 600; font-size: 14px; }
  .btn:hover { background: #0f172a; }
  .link { display: block; margin-top: 0.75rem; font-size: 13px; color: #64748b; }
</style>
